module.exports = __webpack_public_path__ + "static/media/minus-square.e50df03a.svg";